import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'gold' | 'cemento';
};
export const CHECKOUT_URL = 'https://academia-cemento-elite.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg',
  variant = 'gold'
}: Props) {
  const pad = size === 'lg' ? 'px-8 py-[17px] text-[18px]' : 'px-6 py-[14px] text-base';
  const skin = variant === 'cemento' ? 'bg-cemento-soft text-ink shadow-[0_10px_40px_-8px_rgba(214,211,209,0.45)] ring-1 ring-white/40 hover:bg-white hover:shadow-[0_16px_50px_-8px_rgba(214,211,209,0.6)] focus-visible:ring-gold' : 'bg-gold text-ink shadow-[0_10px_40px_-8px_rgba(229,185,75,0.6)] ring-1 ring-gold-soft/60 hover:bg-gold-soft hover:shadow-[0_16px_50px_-8px_rgba(229,185,75,0.85)] focus-visible:ring-white';
  return <a href={href} className={cn('group inline-flex items-center justify-center gap-2 rounded-xl text-center font-extrabold uppercase tracking-wide transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2', skin, pad, className)} style={{
    paddingTop: '15px',
    paddingBottom: '15px',
    fontSize: '18px',
    paddingLeft: '38px',
    paddingRight: '38px'
  }} data-id="element-49" data-mp="198wl1ahllk54">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" data-id="element-50" data-mp="1w941chd4g1me" />
    </a>;
}